import mediaContainer from './mediaContainer'

export default
{
    mediaContainer
};
